import Vue from 'vue';

const UiEventBus = new Vue();

export { UiEventBus as default };
